const sessionKeys = [
  'token',
  'loginStatus',
  'user',
  'menus',
  'resolvedMenuRoutes',
  'params',
  'config',
  'wmsParams',
  'pages',
  'simpleTaskDeadLineNotify',
  'sourceCopiedObj',
  'serviceWorksheetCreator',
  'serviceWorksheetCreatorTwo',
];
const sessionKeyPrefixes = ['biDashboardFilter_', 'biGridStates_'];

let sessionGeneration = 0;
let sessionEnded = false;

export const getSessionGeneration = () => sessionGeneration;
export const isCurrentSession = (generation) => !sessionEnded && generation === sessionGeneration;

export const clearSessionStorage = () => {
  for (const name of ['localStorage', 'sessionStorage']) {
    try {
      const storage = window[name];
      const keys = Array.from({ length: storage.length }, (_, index) => storage.key(index));
      for (const key of keys) {
        if (sessionKeys.includes(key) || sessionKeyPrefixes.some((prefix) => key?.startsWith(prefix))) {
          storage.removeItem(key);
        }
      }
    } catch {
      // A browser may disallow one storage area independently of the other.
    }
  }
};

export const startSession = () => {
  sessionGeneration += 1;
  sessionEnded = false;
  clearSessionStorage();
  return sessionGeneration;
};

export const endSession = () => {
  sessionGeneration += 1;
  sessionEnded = true;
  clearSessionStorage();
};

export const getStoredSessionHomePage = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!localStorage.getItem('token') || !user?.userId) return null;
    return user.homePage ? `/app/${user.homePage}` : '/app';
  } catch {
    return null;
  }
};

export const hasStoredSession = () => getStoredSessionHomePage() !== null;

export const redirectToLogin = () => window.location.replace('/');

// Reset in-memory contexts in other tabs as well as in the tab that logged out.
window.addEventListener('storage', (event) => {
  if (event.storageArea === window.localStorage && event.key === 'token' && event.oldValue && !event.newValue) {
    endSession();
    redirectToLogin();
  }
});

window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;
  if (!hasStoredSession()) redirectToLogin();
  else window.location.reload();
});
